"use client";
import { usePageState } from "@/Context/PageState";
import style from "@/styles/Brochure.module.scss";
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import $ from "jquery";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Image from "next/image";
import img from "../../public/images/brochure.png";
import CloudflareCaptcha from "@/Components/CloudflareCaptcha";
import { useTrackingContext } from "@/Context/TrackingContext";

const Brochure = () => {
  const {
    register,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "all" });

  const submitBtn = useRef(null);

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { CommonSubmitForm, CommonValidateForm } = usePageState();
  const { countryCode } = useTrackingContext();
  const effectRan = useRef(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState(null);

  const handleVerify = (token) => {
    setCaptchaToken(token);
    if (token) setCaptchaError("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const values = getValues();
    // Clean up the phone number before submission

    if (values.mobile && values.mobile.startsWith("0")) {
      values.mobile = values.mobile.substring(1);
    }
    values.mobile = values.mobile.replace(/[\(\)\-]/g, "");
    triggerValidation();
     if (!captchaToken) {
      setCaptchaError("Captcha verification failed");
      return;
    }
    if (CommonValidateForm(5) == true && isValidNum) {
      CommonSubmitForm(5, values);
      setPhoneNumber(""); // Reset phone number after submission
    } else {
      triggerValidation();
    }
  };

  const triggerValidation = () => {
    trigger(); // all fields
  };

  const onChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);
    if (containsOnlyNumbers) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue);
    } else {
      if (!rawValue) {
        setIsValidNum(isValid);
        setPhoneNumber(rawValue);
        setValue("mobile", rawValue);
      }
    }
  };

  useEffect(() => {
    if (effectRan.current === false) {
      $(document).on("focus blur change", ".brochure-form input", function () {
        $(this).val($(this).val().replace(/^\s+/, ""));
      });

      return () => {
        effectRan.current = true;
      };
    }
  }, []);

  return (
    <section className={`${style["brochureformmaindiv"]}`}>
      <div className="container">
        <div className={`${style["contactformbody"]}`}>
          <div className={`${style["left"]}`}>
            <div className={style.Orangespandiv}>
              <span className={style.Orangespan}>Brochure</span>
            </div>
            <h2 className={`${style["title"]} commonsectiontitle`}> Easily & Quickly Downloadable Information</h2>
            <p className={`${style["description"]}`}>Want to know more about Vidyalaya LMS Software, our high quality , informative brochures are just a click away.</p>
            <form id="brochure-form" method="post" encType="multipart/form-data" autoComplete="off" className={`${style["formmain"]} commonformclass brochure-form commonform`}>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <label className={`${style["inputlable"]}`}>Your Name<span>*</span></label>
                <div className={`${style["inputdiv"]}`}>
                  <input
                    className={`${style["input"]}`}
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    {...register("name", {
                      required: "Name is required",
                      pattern: {
                        value: /\p{L}/gu,
                        message: "At least one alphabet character is required",
                      },
                    })}
                  />
                </div>
                <div id="name_error" className={`${style["error"]}`}>
                  {errors.name?.message}
                </div>
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <label htmlFor="mobile_contact" className={`${style["inputlable"]}`}>
                  Mobile Number<span>*</span>
                </label>
                <div className={`${style["inputdiv"]} ${style["w-100"]}`}>
                  {/* hidden input */}
                  <input {...register("mobile")} type="hidden" id="Brochure_mobile_number" value={phoneNumber} name="mobile" />
                  {/* hidden input */}
                  {countryCode && (
                    <IntlTelInput
                      // type="tel"
                      numberType={"MOBILE"}
                      id="mobile_contact"
                      preferredCountries={["us", "gb", "in"]}
                      autoPlaceholder="false"
                      inputClassName={`contact-us-phone ${style["input"]} `}
                      value={phoneNumber}
                      defaultCountry={countryCode}
                      onPhoneNumberChange={onChange}
                      onPhoneNumberBlur={onChange}
                    />
                  )}
                  <div id="brochure-mobile-emsg" className={`${style["error"]}`}>
                    {!isValidNum && "Please enter valid phone number"}
                  </div>
                </div>
                {errors.country && <span className={`${style["error"]}`}>{errors.country.join(", ")}</span>}
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <label className={`${style["inputlable"]}`}>Your Email<span>*</span></label>
                <div className={`${style["inputdiv"]}`}>
                  <input
                    className={`${style["input"]}`}
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i,
                        message: "Email is not valid",
                      },
                    })}
                  />
                </div>
                <div id="email_error" className={`${style["error"]}`}>
                  {errors.email?.message}
                </div>
              </div>
              
                <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                     <div className={`${style["recaptcha"]} c-recaptcha`}>
                        <CloudflareCaptcha onVerify={handleVerify} />
                           <div id="rcptcha" className={`${style["error"]} captcha-error`}>
                              {captchaError}
                            </div>
                      </div>
                </div>

              {/* Add other form fields here */}
              <div className={`${style["formbottompart"]}`}>
                <button ref={submitBtn} className={`${style["buttonsubmit"]} commonformbtn`} type="submit" onClick={onSubmit}>
                  Download Brochure
                </button>
              </div>
            </form>
          </div>
          <div className={`${style["right"]} ${style["bgcard"]}  ${style["bgcardpattrent"]} `}>
            <div className={`${style["img-div"]}`}>
              <Image src={img} alt={"Brochure"} width={0} height={0} className={`${style["main-img"]}`} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Brochure;
